import { map } from 'rxjs';

import { BackendResponse } from '../models/backend-response.model';

/**
 * Unwraps backend response, returning 'meta' property
 *
 * @returns stream with unwrapped content
 */
export function unwrap() {
  return map((source: BackendResponse<any>) => source.meta);
}
